

















import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { CurrencySelectBoxItem } from '@/entities/multi-currency/CurrencySelectBoxItem';

@Component
export default class CurrencySelectBox extends Mixins(BaseMixin) {
    @Prop()
    private readonly selectionItems!: CurrencySelectBoxItem[];

    @Prop()
    private currentCode!: string;

    public get currentCurrency(): CurrencySelectBoxItem | undefined {
        return this.selectionItems.find((item) => item.currencyCode === this.currentCode);
    }
}
